<template lang="html" >
  <div class="newOrder">
    <breadcrumb :nameSection = 'nameSection' :listRoutes = 'listRoutes'></breadcrumb>
    <div class="form-content">
      <div class="form-content-title" >
          <div class="form-content-title-block form-title" >
            <div class="form-title-block form-title-principal">
              <span>Mi Perfil <span v-if="typeUser ==='admin'"> - Aministrador</span> <span v-else> - Operador</span></span>
            </div>

            <div class="form-title-block" v-if="typeUser ==='admin'">
              <b-button v-b-modal.formmodal class="btn btn-primary" v-on:click="editUser()"><i class="fas fa-user-edit"></i>Editar Administrador</b-button>
            </div>

            <div class="form-title-block" v-else="typeUser ==='operator'">
              <b-button v-b-modal.formmodal class="btn btn-primary" v-on:click="editOperator()"><i class="fas fa-user-edit"></i>Editar Operador</b-button>
            </div>
          </div>


        <div class="form-group">
          <label > Nombre del Usuario</label>
          <div class="input-group">
          <input type="text" aria-describedby="nameUSer" class="form-control null" v-model="nameUser">
        </div>
        </div>

        <div class="form-group">
          <label >Apellido del Usuario</label>
          <div class="input-group">
          <input type="text" aria-describedby="lastNameUSer" class="form-control null" v-model="lastnameUser">
        </div>
        </div>

        <div class="form-group">
          <label > Usuario</label>
          <div class="input-group">
          <input type="text" aria-describedby="userName" class="form-control null" v-model="userName">
        </div>
        </div>

        <div class="form-group">
          <label >Sexo: </label>
          <div class="input-group">
          <select name="sexo" id="gender"class='custom-select form-control login__input sen-form-input-with-tooltip 'v-model="genderUser" required>
            <option value="0">Sexo</option>
            <option value="M">Masculino</option>
            <option value="F">Femenino</option>
          </select>
        </div>
        </div>

        <div class="form-group" v-if="typeUser ==='operator'">
          <label >Contraseña</label>
          <div class="input-group">
          <input type="text" aria-describedby="password" v-model="password" class="form-control null" >
        </div>
        </div>

        <div class="form-group" v-if="typeUser ==='admin'">
          <label >Tipo de Usuario</label>
          <div class="input-group">
          <input type="text" aria-describedby="typeUSer" class="form-control null" v-model="typeUser" readonly>
        </div>
        </div>

        <div class="form-group" v-if="typeUser ==='operator'" >
          <label >Tipo de Operador </label>
          <div class="input-group">
          <div>
            <input type="text" aria-describedby="operadorType" class="form-control null" v-model="operadorType" readonly>
          </div>
        </div>
        </div>

        <div class="form-group" v-if="typeUser ==='operator'">
          <label >Código de ciudad </label>
          <div>
            <div class="input-group">
            <input type="text" aria-describedby="cityId" class="form-control null" v-model="cityId" readonly>
          </div>
          </div>
        </div>

        <div class="form-group" v-if="typeUser ==='admin'">
          <label >Codigo del pais: </label>
          <div class="input-group">
          <input type="text" aria-describedby="celUSer" class="form-control null" v-model="codUser" v-floatonly>
        </div>
        </div>

        <div class="form-group" v-if="typeUser ==='admin'">
          <label >Celular: </label>
          <div class="input-group">
          <input type="tel"  maxlength="9" aria-describedby="celUSer" class="form-control login__input sen-form-input-with-tooltip" v-model="celUser" v-floatonly>
        </div>
        </div>

        <div class="form-group" v-if="typeUser ==='admin'">
          <label >Fecha de Nacimiento: </label>
          <div class="input-group">
          <input id="date" type="date"class='form-control login__input sen-form-input-with-tooltip 'v-model="brithUser" placeholder="Fecha de nacimiento" onkeydown="return false" required>
        </div>
        </div>
        <div class="text-right">
          <p></p>
           <b-button v-b-modal.formmodal class="btn btn-primary" v-on:click="desactivar()"><i class="fas fa-user-edit"></i>Desactivar Cuenta</b-button>
         
        </div>

      </div>
    </div>
  </div>

</template>
<script>
import breadcrumb from '@/components/prefab/structures/breadcrumb.vue'
import axios from 'axios'
export default {
  components: { breadcrumb },
  data(){
    return {
      selectionUser: 'perfil',
      /*nameUser: this.$store.state.user.attributes.profile.attributes.name,
      lastnameUser: this.$store.state.user.attributes.profile.attributes.surnames,
      genderUser: this.$store.state.user.attributes.profile.attributes.gender,
      typeUser: this.$store.state.user.attributes.profile.attributes.userable_type,
      celUser:this.$store.state.user.attributes.profile.attributes.cellphone,
      codUser:this.$store.state.user.attributes.profile.attributes.country_code,
      brithUser: this.$store.state.user.attributes.profile.attributes.birthdate,
      idUser: this.$store.state.user.attributes.profile.id,*/
      idUser: this.$store.state.user.id,
      nameUser: this.$store.state.user.attributes.profile.attributes.name,
      lastnameUser: this.$store.state.user.attributes.profile.attributes.surnames,
      genderUser: this.$store.state.user.attributes.profile.attributes.gender,
      codUser:this.$store.state.user.attributes.profile.attributes.country_code,
      celUser:this.$store.state.user.attributes.profile.attributes.cellphone,
      brithUser:this.$store.state.user.attributes.profile.attributes.birthdate,
      typeUser:this.$store.state.user.attributes.profile.attributes.userable_type,

      userName:this.$store.state.user.attributes.username,
      operadorType:this.$store.state.user.attributes.operator_type,
      cityId:this.$store.state.user.attributes.city_id,
      password:this.$store.state.user.attributes.password,
      deleted:this.$store.state.user.attributes.deleted,
      //userable_type: this.$store.state.user.attributes.profile.attributes.userable_type,*/

      /*country_code: '',
      birthdate: '',*/
      nameSection: 'Perfil',
      listRoutes: [{ nameRoute: 'Perfil', titleRoute: 'Perfil' }],
    }
  },
  created(){
   /* this.name = this.name;
    this.surnames = this.lastnameUser;
    this.country_code = this.codUser;
    this.cellphone = this.cellphone;
    this.birthdate = this.brithUser;
    this.gender = this.genderUser;
    this.userable_type = this.typeUser;*/
  },
  methods: {
    //Metodo para el editar
    editUser(){
      let objaux = new Object();
      objaux.name = this.nameUser;
      objaux.surnames= this.lastnameUser;
      objaux.country_code= this.codUser;
      objaux.cellphone= this.celUser;
      objaux.birthdate= this.brithUser;
      objaux.gender= this.genderUser;
      objaux.userable_type= this.typeUser;
      console.log(objaux);
        axios.put(process.env.API_URL+"/api/admin/update-admin-profile/"+this.idUser,objaux)
    .then( response =>{
        console.log(response)
        this.$store.commit('SET_USER',response.data.body)
        this.$store.commit('SET_TOKEN', 'some token')
        localStorage.removeItem('image')
        window.localStorage.setItem( 'user', JSON.stringify(response.data.body))
        window.localStorage.setItem('token', 'some token2')
    });},
    editOperator(){
      let operator = new Object();
      operator.name = this.nameUser;
      operator.surnames= this.lastnameUser;
      operator.gender= this.genderUser;
      operator.username= this.userName;
      operator.password= this.password;
      operator.operator_type= this.operadorType;
      operator.city_id= this.cityId;
      console.log(operator);
        axios.put(process.env.API_URL+"/api/operator/update-operator/"+this.idUser,operator)
    .then( response =>{
        console.log(response)
        this.$store.commit('SET_USER',response.data.body)
        this.$store.commit('SET_TOKEN', 'some token')
        localStorage.removeItem('image')
        window.localStorage.setItem( 'user', JSON.stringify(response.data.body))
        window.localStorage.setItem('token', 'some token2')
    });},
    desactivar(){
      console.log('Estoy en logout')
      this.$store.commit('SET_USER', null)
      this.$store.commit('SET_TOKEN', null)
      if (window.localStorage) {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('token', null)
      }
      this.$router.push('/welcome')
      axios.get(process.env.API_URL+"/api/operator/delete/"+this.idUser)

    .then( response =>{
        console.log(response)
        this.$store.commit('SET_USER',response.data.body)
        this.$store.commit('SET_TOKEN', 'some token')
        localStorage.removeItem('image')
        window.localStorage.setItem( 'user', JSON.stringify(response.data.body))
        window.localStorage.setItem('token', 'some token2')
    });},
  },
}
</script>
<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ProfileAdmin.vue?4dd17bee